var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"comm_breadcrumb_bar"},[_vm._t("buttons",[_c('el-button',{attrs:{"type":"text","size":"small","icon":"el-icon-arrow-left"}},[_vm._v("返回")])]),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bca8b4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonplugin/common/comm_breadcrumb_bar.vue
// module id = null
// module chunks = 